<template>
  <div>

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <!-- PC TOOLBAR -->
      <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

        <v-breadcrumbs class="pl-0 textSecondary--text">
          <v-breadcrumbs-item to="/dashboard/">
            Home
          </v-breadcrumbs-item>
          <span class="pl-2 pr-2">/</span>
          <v-breadcrumbs-item disabled>
            Deliveries
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-layout align-center class="mb-2">
          <div class="title">
            Deliveries
          </div>
        </v-layout>

      </div>

      <v-tabs v-model="activeTab" background-color="foreground" centered fixed-tabs style="max-width: 800px;" class="mx-auto">
        <v-tab>In process</v-tab>
        <v-tab>Complete</v-tab>
      </v-tabs>

    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div>
      <deliveries-in-process v-if="activeTab === 0"></deliveries-in-process>
      <complete-deliveries v-else-if="activeTab === 1"></complete-deliveries>
    </div>

  </div>
</template>

<script>
import GoBack from '@/mixins/GoBack'
import CompleteDeliveries from './DeliveriesListComplete'
import DeliveriesInProcess from './DeliveriesListInProcess'

export default {
  name: 'deliveries',
  mixins: [GoBack],
  components: {
    CompleteDeliveries,
    DeliveriesInProcess
  },
  data () {
    return {
      activeTab: 0
    }
  },
  watch: {
    /* activeTab (nv) {
      this.$router.push({ path: '', query: {}})
    } */
  }
}
</script>
